"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var TimeoutError = /** @class */ (function (_super) {
    __extends(TimeoutError, _super);
    function TimeoutError(message, timeout, statusCode) {
        if (statusCode === void 0) { statusCode = 408; }
        var _this = _super.call(this, message) || this;
        _this.timeout = timeout;
        _this.statusCode = statusCode;
        return _this;
    }
    return TimeoutError;
}(Error));
exports.default = TimeoutError;
//# sourceMappingURL=TimeoutError.js.map